import { render, staticRenderFns } from "./AnimalLastCatchingCell.vue?vue&type=template&id=29961e5c&scoped=true&"
import script from "./AnimalLastCatchingCell.vue?vue&type=script&lang=js&"
export * from "./AnimalLastCatchingCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29961e5c",
  null
  
)

export default component.exports